"use client";
import React from "react";
import { useCartStore } from "@/store/useCartStore";

const CartTooltip = () => {
  const { cart } = useCartStore();
  return cart?.items?.length > 0 ? (
    <div className="absolute top-[-4px] right-[-8px] w-4 h-4 md:w-5 md:h-5 text-white text-xs font-bold  aspect-square z-[2] flex justify-center items-center rounded-full bg-primary">
      {cart?.items?.length}
    </div>
  ) : null;
};

export default CartTooltip;
